export const CURRENT_APP = "admin";

export const APPS = [
	{
		key: "admin",
		label: "Admin",
		description: "Operations and back office",
		url: process.env.REACT_APP_ADMIN_URL || "https://admin.obana.africa",
		restricted: true,
	},
	{
		key: "agent",
		label: "Sales Partner",
		description: "Sell on behalf of customers",
		url: process.env.REACT_APP_AGENT_URL || "https://salesforce.obana.africa",
	},
	{
		key: "vendor",
		label: "Vendor",
		description: "Manage your brand and stock",
		url: process.env.REACT_APP_VENDOR_URL || "https://vendor.obana.africa",
	},
	{
		key: "customer",
		label: "Shop",
		description: "Buy on Obana",
		url: process.env.REACT_APP_SHOP_URL || "https://shop.obana.africa",
	},
];

export const handoffUrl = (app, code) =>
	`${app.url.replace(/\/+$/, "")}/oauth-success?handoff=${encodeURIComponent(code)}`;
